{
  "action": {
    "ok": "Tamam",
    "cancel": "İptal",
    "save": "Kaydet",
    "saved": "Kaydedildi",
    "close": "Kapat",
    "yes": "Evet",
    "no": "Hayır",
    "delete": "Sil",
    "remove": "Kaldır",
    "add": "Ekle",
    "edit": "Düzenle",
    "rename": "Yeniden adlandır",
    "retry": "Yeniden dene",
    "reset": "Sıfırla",
    "apply": "Uygula",
    "confirm": "Onayla",
    "back": "Geri",
    "next": "İleri",
    "done": "Bitti",
    "refresh": "Yenile",
    "copy": "Kopyala",
    "copied": "Kopyalandı",
    "open": "Aç",
    "start": "Başlat",
    "stop": "Durdur",
    "pause": "Duraklat",
    "resume": "Sürdür",
    "continue": "Devam et",
    "clear": "Temizle",
    "search": "Ara",
    "loading": "Yükleniyor…",
    "saving": "Kaydediliyor…",
    "searchPlaceholder": "Ara…",
    "always": "Her zaman",
    "deny": "Reddet",
    "undo": "Geri al",
    "all": "Tümü"
  },
  "confirm": {
    "title": "Onay gerekli: {{tool}}",
    "descriptionEdit": "Vekil bir dosyayı değiştirmek istiyor. Aşağıdaki isteği inceleyin ve devam edip etmeyeceğinize karar verin.",
    "descriptionTool": "Vekil bu aracı çalıştırmak istiyor. Aşağıdaki isteği inceleyin ve devam edip etmeyeceğinize karar verin.",
    "fileModification": "Dosya değişikliği",
    "toolExecution": "Araç çalıştırma",
    "riskSuffix": "{{risk}} risk",
    "command": "Komut",
    "inputLabel": "Girdi:",
    "trustSuggestionTitle": "Güven kalıbı önerisi",
    "trustSuggestionHint": "Her Zaman'ı seçmek, bu proje için eşleşen çağrıları beyaz listeye alır.",
    "yoloDestructiveNote": "YOLO açık. İstek yıkıcı olarak sınıflandırıldığından bu onay penceresi yine de gösteriliyor.",
    "skipApprovalsTitle": "Sonraki onayları atla",
    "skipApprovalsHint": "YOLO modunu etkinleştir; vekil izin istemeden çalışır. Yıkıcı işlemler yine de onay ister.",
    "enableYoloTitle": "YOLO modunu etkinleştir (bu ve sonraki yıkıcı olmayan çağrıları otomatik onayla)",
    "enableYoloBtn": "YOLO'yu etkinleştir",
    "denyAlways": "Her zaman reddet",
    "denyAlwaysTitle": "Bu ve kalıpla eşleşen tüm gelecek çağrıları reddet (d)",
    "noTitle": "Bu tek çağrıyı reddet (Esc / n)",
    "alwaysTitle": "Onayla ve kalıbı proje için hatırla (a)",
    "yesTitle": "Bu tek çağrıyı onayla (y)"
  },
  "status": {
    "connected": "Bağlı",
    "disconnected": "Bağlı değil",
    "connecting": "Bağlanıyor…",
    "reconnecting": "Yeniden bağlanıyor…",
    "ready": "Hazır",
    "error": "Hata",
    "offline": "Çevrimdışı",
    "online": "Çevrimiçi",
    "live": "Canlı",
    "budgetWarning": "bütçe uyarısı",
    "running": "Çalışıyor",
    "inProgress": "Devam ediyor",
    "working": "çalışıyor"
  },
  "time": {
    "justNow": "az önce",
    "secondsAgo_one": "{{count}} saniye önce",
    "secondsAgo_other": "{{count}} saniye önce",
    "minutesAgo_one": "{{count}} dakika önce",
    "minutesAgo_other": "{{count}} dakika önce",
    "hoursAgo_one": "{{count}} saat önce",
    "hoursAgo_other": "{{count}} saat önce",
    "daysAgo_one": "{{count}} gün önce",
    "daysAgo_other": "{{count}} gün önce",
    "compactSecondsAgo": "{{count}} sn önce",
    "compactMinutesAgo": "{{count}} dk önce",
    "compactHoursAgo": "{{count}} sa önce"
  },
  "error": {
    "title": "Bir şeyler ters gitti",
    "body": "Bir oluşturma hatası oluştu. Oturumunuz sunucuda hâlâ etkin — yeniden yüklemek kaldığınız yerden devam eder.",
    "reload": "Sayfayı yeniden yükle",
    "tryAgain": "Tekrar dene"
  },
  "sparkline": {
    "noActivity": "Etkinlik yok",
    "noActivityYet": "Henüz etkinlik yok",
    "activityMax": "Etkinlik sparkline: en fazla {{count}} olay",
    "activityPeak": "Etkinlik sparkline — tepe {{count}} olay/kova"
  }
}
